/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

const CancelBillStatus = {
  edit: {
    name: 'ระบุเลขบิล',
    color: 'warning',
    icon: 'request_page',
  },
  scan: {
    name: 'สแกนสินค้า',
    color: 'info',
    icon: 'qr_code_scanner',
  },
  photo: {
    name: 'ถ่ายภาพ',
    color: 'info',
    icon: 'camera_alt',
  },
  request: {
    name: 'ขออนุมัติ',
    color: 'info',
    icon: 'hourglass_top',
  },
  approve: {
    name: 'อนุมัติ',
    color: 'success',
    icon: 'task_alt',
  },
  reject: {
    name: 'ไม่อนุมัติ',
    color: 'error',
    icon: 'cancel',
  },
  process: {
    name: 'คืนสินค้า',
    color: 'info',
    icon: 'task_alt',
  },
  success: {
    name: 'เสร็จสิ้น',
    color: 'success',
    icon: 'task_alt',
  },
  cancel: {
    name: 'ยกเลิก',
    color: 'error',
    icon: 'cancel',
  },
};

export default CancelBillStatus;
